<template>
  <div class="left-tree">
    <div class="left-tree-title"><span></span><slot></slot></div>
    <el-tree
      ref="tree"
      :data="topicCategorys"
      :props="defaultProps"
      node-key="value"
      :default-expanded-keys="defaultExpandedKeys"
      :current-node-key="this.$route.query.Province"
      accordion
      @node-click="handleNodeClick"
      >
      <span class="custom-tree-node" slot-scope="{ data }">
        <span>{{ data.value }}</span>
        <span class="itemCount">
          {{ data.count }}
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'SearhTreeBook',
  data () {
    return {
      defaultProps: {
        children: 'subdata',
        label: 'value'
      },
      defaultExpandedKeys: [],
      currentNodeKey: ''
    }
  },
  props: {
    topicCategorys: Array
  },
  watch: {
    $route: {
      handler: function (val) {
        this.currentNodeKey = this.$route.query.Province
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['filterList'])
  },
  methods: {
    async handleNodeClick (data) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$router.replace({
          path: 'searchItem',
          query:
          {
            Province: data.value,
            CategoryA: this.$route.query.CategoryA,
            CategoryB: this.$route.query.CategoryB,
            totalIndex: this.$route.query.totalIndex,
            query: this.$route.query.query,
            clear: 1
          }
        })
        for (var i = 0; i < this.filterList.length; i++) {
          if (data.value === this.filterList[i].split(':')[1]) {
            return
          }
        }
        this.filterList.push('Province:' + data.value)
        localStorage.setItem(`filterList`, JSON.stringify(this.filterList))
      }
    }
  },
  mounted () {
    this.currentNodeKey = this.$route.query.CategoryB || this.$route.query.CategoryA
  }
}
</script>

<style lang="less" scoped>
.left-tree {
  float: left;
  background:#f4f4f4;
  /deep/.is-checked {
    .el-tree-node__content {
      .el-tree-node__label {
        color: #1743A5;
        text-decoration-line: underline;
      }
    }
    .el-tree-node__children {
      .el-tree-node__label {
        color: #606266;
        text-decoration-line: none;
      }
    }
  }
 /deep/.is-current {
    .el-tree-node__content {
      .el-tree-node__label {
        color: #1743A5;
        text-decoration-line: underline;
      }
    }
    .el-tree-node__children {
      .el-tree-node__label {
        color: #606266;
        text-decoration-line: none;
      }
    }
  }
  /deep/.el-tree-node__content {
    &:hover {
      background-color: transparent;
      color: #1743a5;
    }
    width:220px;
    height:32px;
  }
  /deep/.el-tree-node__children {
    .is-current {
      .el-tree-node__content {
        background-color: #4160A5;
        .el-tree-node__label {
          color: #FFFFFF;
          background-color: #4160A5;
          text-decoration-line: none;
        }
      }
    }
  }
  .left-tree-title {
    height: 50px;
    border-bottom: 1px solid #DDDDDD;
    line-height: 50px;
    font-size: 16px;
    color: #333333;
    position: relative;
    width: 210px;
    margin: 0 auto;
    text-indent: 30px;
    span {
      &::before {
        content: "";
        position: absolute;
        height: 14px;
        width: 14px;
        background: url("../../assets/imgs/title-bg-top.png") no-repeat;
        left: 0;
        top: 18px;
      }
      &::after {
        content: "";
        position: absolute;
        height: 14px;
        width: 14px;
        background: url("../../assets/imgs/title-bg-top.png") no-repeat;
        top: 23px;
        left: 6px;
      }
    }
  }
  /deep/.el-tree {
    background:#f4f4f4;
    margin-top: 10px;
    .el-tree-node__content {
      box-sizing: border-box;
      width: 220px;
      .custom-tree-node {
        width: 100%;
        .itemCount {
          float: right;
          margin-right: 10px;
          color: #999999;
        }
      }
    }
    .el-tree-node__children {
      box-sizing: border-box;
      .el-tree-node__content {
        width: 220px;
        box-sizing: border-box;
        .custom-tree-node {
          width: 100%;
          .itemCount {
            float: right;
            margin-right: 10px;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/treeList/SearhTreeBook.vue